function addWishlistProductToDrawer(variantId) {
  fireCustomGA4Event("click_wishlist_atc_product");
  addToCartOpenDrawer(variantId, 1);
}

async function createProductGridItem(title, variantId, price, imgUrl, productUrl, productCurrency, unit_price_measurement) {
  return `
    <li class="product-item">
        <div class="product-item__image-wrapper">
            <a href="${productUrl}" class="product-item__image object-cover" data-ga4-event-name="click_wishlist_product">
                <img src="${imgUrl}"
                    alt="${productUrl}" width="2048" height="2048.0" loading="lazy"
                    sizes="100vw">
            </a>

            <button class="product-item__remove-wishlist" onclick="removeFromWishlistAndUpdate('${variantId}');">
                <svg class="icon icon--close" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g transform="rotate(-315 10 10)">
                        <path fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="2.6" d="M10.093 22.476L10.09-1.94"></path>
                        <path fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="2.6" d="M22.476 10.333l-24.416.002"></path>
                    </g>

                </svg>
            </button>
            <button class="product-item__direct-atc" onclick="addWishlistProductToDrawer('${ variantId }');">
                    <svg class="icon icon--cart" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
                        <path d="M13.566 16.76a.977.977 0 0 1-.969.985h-9.69a.977.977 0 0 1-.969-.986V6.905h1.938v.985c0 .545.434.986.97.986a.977.977 0 0 0 .968-.986v-.985H9.69v.985c0 .545.434.986.97.986a.977.977 0 0 0 .968-.986v-.985h1.938zM5.814 3.945c0-1.09.865-1.973 1.933-1.973 1.067 0 1.932.883 1.932 1.973v.986H5.814zm8.721.986h-2.907v-.986C11.628 1.766 9.893 0 7.752 0c-2.14 0-3.876 1.767-3.876 3.946v.986H.97A.978.978 0 0 0 0 5.92v10.85c0 1.635 1.302 2.96 2.907 2.96h9.69c1.606 0 2.907-1.325 2.907-2.96V5.92a.978.978 0 0 0-.969-.987z"></path>
                    </svg>
            </button>
        </div>

        <div class="product-item__info">
          <div class="product-item__info-left">
            <h3 class="product-item__title">
              <a href="/products/facetheory-supergel-moisturiser-m3">${title}</a>
          </h3>

          <p class="product-price__container">
              <span class="product-item__price product-price">
              <span class="transcy-money">${numberWithCommas(price)} ${productCurrency}</span>                    
              </span>
          </p>
          </div>
          <div class="product-item__info-right">
            <span>${unit_price_measurement == undefined ? '' : unit_price_measurement.quantity_value} 
            ${unit_price_measurement == undefined ? '' : unit_price_measurement.quantity_unit}</span>
          
          </div>
  
        </div>
    </li>
  `;
}

async function loadWishlist() {
  const wishlistContent = document.querySelector("[data-wishlist-content]");
  const wishlistNoContent = document.querySelector("[data-wishlist-no-content]");
  const addToCartAllBtn = document.querySelector('[data-action="add-to-cart-all"]');

  const wishlist = await getCurrentWishlist();
  let newContent = "";

  if (wishlist.length > 0) {
    await wishlist.forEach(async wishlistItem => {
      const { title, variantId, imgUrl, productUrl, productHandle, productCurrency, isWishlistVariantType } = wishlistItem;
      let product = await checkCurrentWishes(productHandle);
      let productGridItem;
      if (isWishlistVariantType) {
        let variantPicked;
        product.variants.forEach(variant => {
          if (variant.id == variantId) {
            variantPicked = variant
          }
        })
        productGridItem = await createProductGridItem(variantPicked.name, variantId, product.price, imgUrl, productUrl, productCurrency, variantPicked.unit_price_measurement);

      } else {
        productGridItem = await createProductGridItem(title, variantId, product.price, imgUrl, productUrl, productCurrency);
      }
      newContent = newContent + productGridItem;
      wishlistContent.innerHTML = newContent;
      wishlistNoContent.classList.add("hide");
      addToCartAllBtn.classList.remove("hide");
    });
  } else {
    wishlistContent.innerHTML = "";
    wishlistNoContent.classList.remove("hide");
    addToCartAllBtn.classList.add("hide");
  }

  registerCustomGa4EventElements();

}

function removeFromWishlistAndUpdate(variantId) {
  removeFromWishlist(variantId);
  loadWishlist();
}

loadWishlist();

function addAllWishesList() {
  const wishlist = getCurrentWishlist();
  const addToCartAllBtn = document.querySelector('[data-action="add-to-cart-all"]');
  const items = []
  addToCartAllBtn.addEventListener('click', async () => {
    wishlist.forEach(async wishlistItem => {
      const { variantId } = wishlistItem;

      items.push({
        id: variantId,
        quantity: 1
      })

    });
    await addToCartAll(items);
    openCartDrawerV2();
  })

  async function addToCartAll(items) {
    const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    });

    return res;
  }
}

async function checkCurrentWishes(productHandle) {
  const url = `${window.Shopify.routes.root}products/${productHandle}.js`;
  const res = await fetch(url);
  const product = await res.json();
  return product;
}

function numberWithCommas(x) {
  return (x / 100).toString().replace('.', ",");
}

addAllWishesList();